import { Component, OnInit, Optional, Inject, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PershingTranslationService, IAuthorizationService } from '@pershing/pershing-core';
import { QuoteToggleService } from '../../services/quotetoggle.service';
import { QuoteRef } from '../../models/quoteRef-model';
import { QuoteToggleConstants } from '../../utils/quotetoggle-constants';
import moment from 'moment-timezone';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TradingService } from '@pershing/trading-common';

@Component({
    selector: 'quotetoggle',
    templateUrl: './quotetoggle.component.html'
})
export class QuoteToggleComponent implements OnInit {

    theme: string;
    quoteType: string = QuoteToggleConstants.DELAYED_QUOTE;
    realTimeRefOn: boolean = false;
    isRTQuoteEntitled: boolean = false;
    asOfDate: string = '-:--';
    asOfDateDefault: string = new Date().toISOString();
    quoteAction: string = '';
    quoteReference: QuoteRef = { pageName: 'N/A', realTimeRefOn: false, asOfDate: this.asOfDateDefault, agreementSigned: false, quoteAction: '', isRTQuoteEntitled: this.isRTQuoteEntitled }

    isAdvisor: boolean = false;
    enableRealtimeQuote: boolean = true;
    rtRefButton = false;
    platform: string = '';
    isExchangeAgreementSignedByUser: boolean;
    getExchangeAgreeEvent: boolean = false;
    showAsofDate :  boolean = false;
    qutoggleResponse: any;
    @Input() set quoteRef(qr: QuoteRef) {
        if (qr) {
            this.quoteReference = qr;
            this.rtRefButton = qr.realTimeRefOn;
            this.isRTQuoteEntitled = qr.isRTQuoteEntitled;
        }
    }

    constructor(
        private translationService: PershingTranslationService,
        private quoteToggleService: QuoteToggleService,
        private authorizationService: IAuthorizationService,
        public datepipe: DatePipe,
        private tradingService: TradingService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        if (!!appSettings && !!appSettings.ibdConfigMap && !!appSettings.ibdConfigMap.themeType) {
            this.theme = appSettings.ibdConfigMap.themeType;
        }
        this.isAdvisorVal(appSettings);
        this.platform = appSettings.platform;
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-quotetoggle', 'node_modules/@pershing/nxi-ng-quotetoggle/lib');
 // Quote Selection and Content is 2 way communication.  Once user toggle/refresh, we tell component to refresh data.
        // We also need to listen for updated data such as as of date to display the updated value accordingly.
        this.qutoggleResponse = this.quoteToggleService.quoteReference$.subscribe(quoteReferenceList => {
            this.processData(quoteReferenceList);
        },(error) => {
            console.log(error);
          });
        this.tradingService.onEntitlementsSubject$.subscribe((success) => {
            if(success && success.response) {
              console.log("entitlements response ====", success);
              this.isExchangeAgreementSignedByUser = success.response.isExchangeAgreementSignedByUser;
              if (this.getExchangeAgreeEvent) {
                this.getExchangeAgreeEvent = false;
                this.getExchangeAgreementSignedByUser();
              }
            }
          },
          (error) => console.log("Error in entitlements response ====", error)
        );
        this.tradingService.getEntitlements(this.platform);
    }
    processData(quoteReferenceList) {
        if (quoteReferenceList && !!this.quoteReference.pageName) {
            quoteReferenceList.forEach(item => {
                if (item.pageName === this.quoteReference.pageName) {
                     this.isRTQuoteEntitled = item.isRTQuoteEntitled;
                    this.realTimeRefOn = item.realTimeRefOn && item.agreementSigned;
                    this.quoteType = this.realTimeRefOn ? QuoteToggleConstants.REALTIME_QUOTE : QuoteToggleConstants.DELAYED_QUOTE;
                    if(!!item.asOfDate) {
                       this.showAsofDate = true;
                      this.updateAsofDate(item);
                    }
                    this.quoteAction = '';
                }
            });
        }
    }
    updateAsofDate(response: any){
        if (response.pageName == "rgl") {
            this.asOfDate = this.datepipe.transform(response.asOfDate, "MM/dd/yyyy");
         } else if (response.pageName == "ugl") {
            let today = this.dateConverter(new Date());
            let responsedate =  this.dateConverter(response.asOfDate.split('T')[0]);
            if (responsedate === today) {
                this.asOfDate =  moment(response.asOfDate).tz(QuoteToggleConstants.TIME_ZONE, true).format(QuoteToggleConstants.SHORTTIME_FORMAT);
               
            } else {
                this.asOfDate = this.datepipe.transform(responsedate, "MM/dd/yyyy");
            }
        } else {
            this.asOfDate = moment(response.asOfDate).tz(QuoteToggleConstants.TIME_ZONE).format(QuoteToggleConstants.SHORTTIME_FORMAT);
        } 
        return this.asOfDate;
    }
    
    dateConverter(value: any): any {
        return this.datepipe.transform(value, "M/d/yy");
    }
    updateEventByExchangeAgree() {
        this.getExchangeAgreeEvent = true;
    }

    getExchangeAgreementSignedByUser() {
        this.quoteToggleService.exchangeAgreementData({isExchangeAgreementSignedByUser : this.isExchangeAgreementSignedByUser});
        this.toggleRefFun();
    }

    toggleRefClick(event: MatSlideToggleChange) {
        this.rtRefButton = event.checked;
        if(this.isExchangeAgreementSignedByUser !== undefined) {
            this.quoteToggleService.exchangeAgreementData({isExchangeAgreementSignedByUser : this.isExchangeAgreementSignedByUser});
        }
        // Does toggling only if state is not the same.
        // Better UX would be disable or muted quote option currently displayed.
        // So it's not a clickable element.
            this.toggleRefFun();
    }

    toggleRefFun(){
        this.quoteAction = QuoteToggleConstants.TOGGLE_ACTION;
        if (this.realTimeRefOn && !this.rtRefButton) {
            this.realTimeRefOn = false;
            this.quoteType = this.realTimeRefOn ? QuoteToggleConstants.REALTIME_QUOTE : QuoteToggleConstants.DELAYED_QUOTE;
            this.updateQuoteRef();
        } else if ((!this.realTimeRefOn && this.rtRefButton) || (this.isExchangeAgreementSignedByUser)) {
            this.realTimeRefOn = true;
            this.updateQuoteRef();
        }
    }

    onRefreshClick() {
        this.quoteAction = QuoteToggleConstants.REFRESH_ACTION;
        this.updateQuoteRef();
    }

    updateQuoteRef() {
        this.quoteReference.realTimeRefOn = this.realTimeRefOn;
        this.quoteReference.quoteAction = this.quoteAction;
        this.quoteReference.asOfDate = new Date().toISOString();
        this.quoteToggleService.updateQuoteRef(this.quoteReference);
    }
    ngOnDestroy(): void {
        if (this.qutoggleResponse) {
            this.qutoggleResponse.unsubscribe();
        }
        
    }
    isAdvisorVal(appSettings){
            this.isAdvisor = !!appSettings.isAdvisor ? appSettings.isAdvisor : false;
    }

}
